
import {defineComponent, PropType} from 'vue'
import {UIStateDto} from "@/dtos/UIStateDto";
import BasePlaceholderTable from "@/components/UI/Bootstrap/BasePlaceholderTable.vue";
import CatalogProductsOverviewTableItem
  from "@/components/layouts/catalog/products/CatalogProductsOverviewTableItem.vue";
import {ProductCategorizationRestService} from "@/services/rest/cpc-product-mgmt/ProductSortWeightRestService";
import {AbilityContext} from "@/context/AbilityContext";
import {
  PagedCatalogProductWithImageOverviewResultsRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/PagedCatalogProductWithImageOverviewResultsRestDtoModel";

export default defineComponent({
  name: "CatalogProductsOverviewTable",
  components: {CatalogProductsOverviewTableItem, BasePlaceholderTable},
  emits: ['dataChanged'],
  data() {
    return {
      draggedIndex: -1,
    }
  },
  props: {
    productsOverview: {
      type: Object as PropType<PagedCatalogProductWithImageOverviewResultsRestDtoModel>,
      required: true
    },
    hasProducts: {
      type: Boolean,
      required: true
    },
    ui: {
      type: UIStateDto,
      required: true
    },
    onlyProductsWithCustomWeights: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    AbilityContext() {
      return AbilityContext
    },
    colCount() {
      return AbilityContext.isAuthorizedForFeature('ADVANCED_MGMT_CUSTOMER_CATALOG_PRODUCTS') ? 7 : 6;
    }
  },
  methods: {
    dragStart(event: any, index: number) {
      this.draggedIndex = index;
    },
    async drop(event: any, targetIndex: number) {
      const draggedItem = this.productsOverview.results[this.draggedIndex];
      const targetItem = this.productsOverview.results[targetIndex];
      await ProductCategorizationRestService.getInstance().moveCustomerProductSortWeightTo(
        draggedItem.product.product_code, {sort_weight: targetItem.product.customer_product_sort_weight});
      this.$emit('dataChanged');
    },
  }
})
